import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["data", "value", "children", "className", "width", "onChange", "portalZIndex", "onCancel", "shouldUpdate"];
import PropTypes from 'prop-types';
import React from 'react';
import Dropdown from '@jd/jmtd/es/Dropdown';
import DropdownPanel from '@jd/jmtd/es/DropdownPanel';
import CheckboxGroup from '@jd/jmtd/es/CheckboxGroup';
import classNames from '@jd/jmtd-tools/es/classnames';
import Button from '@jd/jmtd/es/Button';
import { trackEvent } from '@jd/jmtd/es/tools/eventTracking';
import ConfigConsumerProvider from '@jd/jmtd/es/ConfigConsumerProvider';
import { getLocale } from '@jd/jmtd/es/locale';
import { PortalZIndexContext } from '@jd/jmtd/es/PortalZIndex';
import ConfigConsumer from '@jd/jmtd/es/ConfigConsumer';
var TEMP_VALUE = Symbol('tempValue');
var LAST_OPEN = Symbol('lastOpen');
export default function DropdownCheckboxGroup(_ref) {
  var data = _ref.data,
      value = _ref.value,
      children = _ref.children,
      className = _ref.className,
      width = _ref.width,
      onChange = _ref.onChange,
      portalZIndex = _ref.portalZIndex,
      onCancel = _ref.onCancel,
      shouldUpdate = _ref.shouldUpdate,
      other = _objectWithoutProperties(_ref, _excluded);

  var inner = /*#__PURE__*/React.createElement(ConfigConsumerProvider, {
    portalZIndexAdjust: true
  }, function (_ref2) {
    var locale = _ref2.locale,
        _ref2$jmtpDropdownChe = _ref2.jmtpDropdownCheckboxGroupCancelButtonProps,
        jmtpDropdownCheckboxGroupCancelButtonProps = _ref2$jmtpDropdownChe === void 0 ? {
      outline: true
    } : _ref2$jmtpDropdownChe;
    return /*#__PURE__*/React.createElement(Dropdown, {
      autoAdjustOverflow: "main",
      placement: "bottomRight",
      noDropdownShadow: true,
      className: classNames('jmtp-dropdown-checkbox-group', className),
      dropdown: function dropdown(_ref3) {
        var _state$TEMP_VALUE;

        var state = _ref3.state,
            open = _ref3.open,
            setOpen = _ref3.setOpen,
            update = _ref3.update;

        if (open && !state[LAST_OPEN]) {
          delete state[TEMP_VALUE];
        }

        state[LAST_OPEN] = open;
        state[TEMP_VALUE] = (_state$TEMP_VALUE = state[TEMP_VALUE]) !== null && _state$TEMP_VALUE !== void 0 ? _state$TEMP_VALUE : value;
        return /*#__PURE__*/React.createElement(DropdownPanel, {
          style: {
            width: width
          }
        }, /*#__PURE__*/React.createElement(CheckboxGroup, _extends({
          trackComponentName: "CheckboxDropdown",
          size: "small",
          showLength: true,
          showReset: true,
          showClear: true,
          onChange: function onChange(nextValue) {
            state[TEMP_VALUE] = nextValue;
            update();
          }
        }, other, {
          data: data,
          value: state[TEMP_VALUE],
          formProps: {
            formItemClassName: 'jmtd-form-item-center'
          }
        })), /*#__PURE__*/React.createElement("div", {
          className: "jmtp-dropdown-checkbox-group-buttons"
        }, /*#__PURE__*/React.createElement(Button, _extends({
          size: "small"
        }, jmtpDropdownCheckboxGroupCancelButtonProps, {
          className: "jmtp-dropdown-checkbox-group-cancel",
          onClick: function onClick() {
            setOpen(false);
            onCancel();
            trackEvent({
              componentName: 'CheckboxDropdown',
              eventName: 'cancel'
            });
          }
        }), getLocale(locale).common.cancel), /*#__PURE__*/React.createElement(Button, {
          disabled: state[TEMP_VALUE].length === 0,
          size: "small",
          semantic: "primary",
          className: "jmtp-dropdown-checkbox-group-confirm",
          onClick: function onClick() {
            if (shouldUpdate(state[TEMP_VALUE], value)) {
              onChange(state[TEMP_VALUE]);
            }

            setOpen(false);
            trackEvent({
              componentName: 'CheckboxDropdown',
              eventName: 'confirm'
            });
          }
        }, getLocale(locale).common.confirm)));
      }
    }, children);
  });
  return /*#__PURE__*/React.createElement(ConfigConsumer, null, function (context) {
    // 如果在自适应中，或者未设置portalZIndex，采用默认值
    if (context.portalZIndexAdjust || portalZIndex === null) {
      return inner;
    }

    return /*#__PURE__*/React.createElement(PortalZIndexContext.Provider, {
      value: portalZIndex ? portalZIndex - 1 : portalZIndex
    }, inner);
  });
}
DropdownCheckboxGroup.propTypes = {
  children: PropTypes.node,
  data: PropTypes.any,
  value: PropTypes.any,
  className: PropTypes.string,
  width: PropTypes.number,
  onChange: PropTypes.func,
  onCancel: PropTypes.func,
  portalZIndex: PropTypes.number,
  shouldUpdate: PropTypes.func
};
DropdownCheckboxGroup.defaultProps = {
  children: null,
  data: null,
  value: null,
  className: '',
  width: 448,
  portalZIndex: 299,
  onChange: function onChange() {},
  onCancel: function onCancel() {},
  shouldUpdate: function shouldUpdate(previous, next) {
    return JSON.stringify(previous) !== JSON.stringify(next);
  }
};